import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ChatChannelRBAC = {
  pageID: '6c1e49a701724f655fcd929932290946',
  elementID: {
    ViewChatChannelList: 'b6b96b7c0aa382289c3afd89288d6991',
  },
} as const

export const useRBACChatChannelPage = createUseRBAC(ChatChannelRBAC.elementID)

export type UseRBACChatChannelPageType = ReturnType<typeof useRBACChatChannelPage>
